import { render, staticRenderFns } from "./EnvironmentCreate.vue?vue&type=template&id=c9165370&scoped=true&"
import script from "./EnvironmentCreate.vue?vue&type=script&lang=js&"
export * from "./EnvironmentCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9165370",
  null
  
)

export default component.exports